"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_transition_group_1 = require("react-transition-group");
var core_1 = require("@material-ui/core");
var react_infinite_scroll_component_1 = __importDefault(require("react-infinite-scroll-component"));
var constants_1 = require("../../constants");
var NotificationsContext_1 = require("../../context/NotificationsContext");
var NotificationCard_1 = __importDefault(require("../notification-card/NotificationCard"));
var NotificationPanelHeader_1 = __importDefault(require("../notification-panel-header/NotificationPanelHeader"));
var Loader_1 = __importDefault(require("../loader/Loader"));
var EndMessage_1 = __importDefault(require("../end-message/EndMessage"));
var useStyles = core_1.makeStyles(function (theme) {
    var notificationsPanel = theme.variables.palette.notificationsPanel;
    var card = notificationsPanel.card;
    return {
        paperContainer: {
            borderRadius: 4,
            maxWidth: 500,
            width: '100%',
            background: card.background,
        },
        messagesContainer: {
            maxHeight: function (props) { return props.containerHeight; },
            overflow: 'auto',
            padding: "0 " + theme.spacing(3) + "px",
            background: theme.palette.background.paper,
        },
        listTransitionExit: {
            opacity: 1,
        },
        listTransitionExitActive: {
            opacity: 0,
            transition: theme.transitions.create('opacity', {
                easing: theme.transitions.easing.easeInOut,
                duration: theme.transitions.duration.short,
            }),
        },
    };
});
var NotificationPanel = function (props) {
    var _a = props.elementsPerPage, elementsPerPage = _a === void 0 ? constants_1.defaultElementsPerPage : _a, loadNotifications = props.loadNotifications, anchorEl = props.anchorEl, setPopoverClose = props.setPopoverClose, isOpen = props.isOpen, changeViewed = props.changeViewed, setNotViewedNotifications = props.setNotViewedNotifications, notViewedNotifications = props.notViewedNotifications, removeNotification = props.deleteNotification, loadCountNotViewedMessages = props.loadCountNotViewedMessages;
    var _b = react_1.useState([]), notifications = _b[0], setNotifications = _b[1];
    var _c = react_1.useState(false), isNotificationsLoading = _c[0], setIsNotificationsLoading = _c[1];
    var _d = react_1.useState(false), needLoading = _d[0], setNeedLoading = _d[1];
    var _e = react_1.useState(true), hasMore = _e[0], setHasMore = _e[1];
    var containerHeight = react_1.useMemo(function () {
        return elementsPerPage * constants_1.defaultCardHeight;
    }, [elementsPerPage]);
    var classes = useStyles({ containerHeight: containerHeight });
    react_1.useEffect(function () {
        if (!isOpen) {
            return;
        }
        // сбрасываем до начальных значений при каждом монтировании
        setHasMore(true);
        loadNotifications(__assign(__assign({}, constants_1.defaultFilters), { filter: {}, startIndex: 0 })).then(function (notificationsList) {
            var listLength = notificationsList.length;
            if (!listLength || listLength < constants_1.defaultPageSize) {
                setHasMore(false);
            }
            setNotifications(notificationsList);
        });
        loadCountNotViewedMessages().then(setNotViewedNotifications);
    }, [
        setNotifications,
        loadNotifications,
        isOpen,
        setHasMore,
        loadCountNotViewedMessages,
        setNotViewedNotifications,
    ]);
    var loadMoreNotifications = react_1.useCallback(function () {
        setIsNotificationsLoading(true);
        setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var nextNotifications;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadNotifications(__assign(__assign({}, constants_1.defaultFilters), { filter: {}, startIndex: notifications.length }))];
                    case 1:
                        nextNotifications = _a.sent();
                        setNeedLoading(false);
                        if (nextNotifications.length) {
                            setIsNotificationsLoading(false);
                            setNotifications(function (currentNotifications) { return currentNotifications.concat(nextNotifications); });
                            return [2 /*return*/];
                        }
                        setHasMore(false);
                        return [2 /*return*/];
                }
            });
        }); }, 500);
    }, [loadNotifications, setHasMore, notifications]);
    react_1.useEffect(function () {
        if (!needLoading) {
            return;
        }
        loadMoreNotifications();
    }, [needLoading, loadMoreNotifications]);
    var deleteNotification = react_1.useCallback(function (id, viewed, catchFunc) {
        var filteredNotifications = notifications.filter(function (notification) { return notification.id !== id; });
        setNotifications(filteredNotifications);
        if (!viewed) {
            setNotViewedNotifications(function (prevValue) { return prevValue - 1; });
        }
        // необходимо для случая, когда удаляем последние уведомления до момента пропадания скролла
        // и нам надо получить уведомления со следующей страницы
        if (filteredNotifications.length <= elementsPerPage && hasMore && !isNotificationsLoading) {
            setNeedLoading(true);
        }
        removeNotification(id).catch(function () {
            setNotifications(notifications);
            setNotViewedNotifications(notViewedNotifications);
            catchFunc();
        });
    }, [
        notifications,
        elementsPerPage,
        hasMore,
        isNotificationsLoading,
        removeNotification,
        setNotifications,
        setNotViewedNotifications,
        notViewedNotifications,
    ]);
    var toggleViewed = react_1.useCallback(function (id, viewed) {
        setNotViewedNotifications(function (prevValue) { return (viewed ? prevValue - 1 : prevValue + 1); });
        setNotifications(function (prevNotifications) {
            return prevNotifications.map(function (notification) {
                if (notification.id === id) {
                    return __assign(__assign({}, notification), { viewed: viewed });
                }
                return notification;
            });
        });
        changeViewed(id, viewed).catch(function () {
            setNotViewedNotifications(notViewedNotifications);
            setNotifications(notifications);
        });
    }, [notifications, setNotifications, setNotViewedNotifications, changeViewed, notViewedNotifications]);
    return (react_1.default.createElement(NotificationsContext_1.NotificationsContext.Provider, { value: { deleteNotification: deleteNotification, toggleViewed: toggleViewed } },
        react_1.default.createElement(core_1.Popover, { open: isOpen, onClose: setPopoverClose, anchorEl: anchorEl, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'right',
            }, PaperProps: { className: classes.paperContainer } },
            react_1.default.createElement(NotificationPanelHeader_1.default, null),
            react_1.default.createElement(core_1.Box, { id: "scrollable-paper", className: classes.messagesContainer },
                react_1.default.createElement(react_infinite_scroll_component_1.default, { dataLength: notifications.length, next: loadMoreNotifications, scrollThreshold: 0.99, hasMore: hasMore, loader: react_1.default.createElement(Loader_1.default, null), scrollableTarget: "scrollable-paper", endMessage: react_1.default.createElement(EndMessage_1.default, { hasNotifications: !!notifications.length }) },
                    react_1.default.createElement(react_transition_group_1.TransitionGroup, null, notifications.map(function (notification) { return (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: notification.id, timeout: 250, classNames: {
                            exit: classes.listTransitionExit,
                            exitActive: classes.listTransitionExitActive,
                        } },
                        react_1.default.createElement(NotificationCard_1.default, { notification: notification }))); })))))));
};
exports.default = NotificationPanel;
